import React__default, { useRef, useState } from 'react';
import styled, { css } from 'styled-components';
import { Transition } from 'react-transition-group';
import { I as Icon } from '../Icon/Icon-AcXbY_t4.js';
import { H as Heading } from '../Heading/Heading-B4IwLvTA.js';
import { T as TaktIdProvider } from '../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';
import { c as caretRight } from '../LocalModules/storm-ui-icons/dist/esm/classicIcons-CHpXglL2-uH6-91Kn.js';

const ExpanderTabIcon = /*#__PURE__*/styled(Icon).withConfig({
  componentId: "sc-storm-ui-40027066__sc-lcv7v-0"
})(["&& > svg{@media (prefers-reduced-motion:no-preference){transition:transform 150ms ease-in-out;}", "}[dir=\"rtl\"] && > svg{@media (prefers-reduced-motion:no-preference){transition:transform 150ms ease-in-out;}/*! @noflip */ transform:rotate(180deg);", "}"], ({
  $opened
}) => $opened && css(["/*! @noflip */ transform:rotate(90deg);"]), ({
  $opened
}) => $opened && css(["/*! @noflip */ transform:rotate(90deg);"]));
const ExpanderWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40027066__sc-lcv7v-1"
})(["width:100%;"]);
const ExpanderTab = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40027066__sc-lcv7v-2"
})(["cursor:pointer;border:none;background:none;padding-block-start:", ";padding-block-end:", ";padding-inline-start:0;padding-inline-end:", ";width:100%;display:flex;align-items:center;"], ({
  theme
}) => theme.spacing.xxsmall.default, ({
  theme
}) => theme.spacing.xxsmall.default, ({
  theme
}) => theme.spacing.xxsmall.default);
const ExpanderHeading = /*#__PURE__*/styled(Heading).withConfig({
  componentId: "sc-storm-ui-40027066__sc-lcv7v-3"
})(["margin-block-start:0;margin-block-end:0;margin-inline-start:", ";margin-inline-end:0;display:inline-block;"], ({
  theme
}) => theme.spacing.xsmall.default);
const ExpanderContent = /*#__PURE__*/styled.section.withConfig({
  componentId: "sc-storm-ui-40027066__sc-lcv7v-4"
})(["border-top:", ";padding-block-start:", ";padding-block-end:", ";padding-inline-start:0;padding-inline-end:", ";overflow-y:hidden;max-height:0;@media (prefers-reduced-motion:no-preference){transition:", ";}", ""], ({
  theme
}) => theme.border.subtle.default, ({
  theme
}) => theme.spacing.xxsmall.default, ({
  theme
}) => theme.spacing.xxsmall.default, ({
  theme
}) => theme.spacing.xxsmall.default, ({
  $transition
}) => $transition, ({
  $transitionState
}) => ({
  entering: 'height: 0',
  entered: 'max-height: 100vh'
})[$transitionState]);
const Expander = ({
  defaultOpen = false,
  transition = undefined,
  transitionDuration = 0,
  children,
  label,
  taktId,
  taktValue,
  ...rest
}) => {
  const containerRef = useRef(null);
  const [isOpen, setIsOpen] = useState(() => defaultOpen);
  const handleClick = () => {
    setIsOpen(prevState => !prevState);
  };
  return /*#__PURE__*/React__default.createElement(TaktIdProvider, {
    taktId: taktId,
    taktValue: taktValue,
    fallbackId: createStormTaktId('expander')
  }, /*#__PURE__*/React__default.createElement(ExpanderWrapper, rest, /*#__PURE__*/React__default.createElement(ExpanderTab, {
    onClick: handleClick
  }, /*#__PURE__*/React__default.createElement(ExpanderTabIcon, {
    type: caretRight,
    $opened: isOpen,
    color: "default"
  }), /*#__PURE__*/React__default.createElement(ExpanderHeading, {
    renderAs: "h3",
    typeface: "ember"
  }, label)), /*#__PURE__*/React__default.createElement(Transition, {
    timeout: transitionDuration,
    appear: true,
    in: isOpen,
    nodeRef: containerRef
  }, state => {
    if (state === 'exited') return null;
    return /*#__PURE__*/React__default.createElement(ExpanderContent, {
      $transitionState: state,
      $transition: transition,
      ref: containerRef
    }, children);
  })));
};

export { Expander as E };
//# sourceMappingURL=Expander-DcqVAj80.js.map
